import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import AuthShell from "@/components/marketplace/AuthShell";
import { FIELD_STYLES } from "@/pages/LoginPage";
import api from "@/lib/api";

export default function ResetPasswordPage() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(sp.get("token") || "");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (newPassword.length < 8) return toast.error("Password must be at least 8 characters.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: newPassword });
      toast.success("Password reset. Please sign in.");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.error || "Could not reset password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Set a new password." subtitle="Pick something strong you'll remember.">
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <Field label="Reset token">
          <input
            type="text"
            required
            value={token}
            onChange={(e) => setToken(e.target.value)}
            placeholder="Paste the token from your email"
            data-testid="reset-token"
            className="input-primary"
          />
        </Field>
        <Field label="New password">
          <input
            type="password"
            required
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="At least 8 characters"
            data-testid="reset-new-password"
            className="input-primary"
          />
        </Field>
        <button
          type="submit"
          disabled={loading}
          data-testid="reset-submit"
          className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#165a71] text-white px-6 py-3 font-medium hover:bg-[#11485a] disabled:opacity-60 transition-colors"
        >
          {loading ? "Saving…" : (<>Save new password <ArrowRight className="h-4 w-4" /></>)}
        </button>
        <p className="text-sm text-center text-[#252A34]/70 pt-2">
          <Link to="/login" className="font-medium text-[#165a71]" data-testid="reset-back-to-login">Back to sign in</Link>
        </p>
      </form>
      <style>{FIELD_STYLES}</style>
    </AuthShell>
  );
}

const Field = ({ label, children }) => (
  <label className="block">
    <span className="mb-1.5 block text-sm font-medium text-[#071b22]">{label}</span>
    {children}
  </label>
);
